import { render, staticRenderFns } from "./PageComponentSelector.vue?vue&type=template&id=5637192e&"
import script from "./PageComponentSelector.vue?vue&type=script&lang=js&"
export * from "./PageComponentSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5637192e')) {
      api.createRecord('5637192e', component.options)
    } else {
      api.reload('5637192e', component.options)
    }
    module.hot.accept("./PageComponentSelector.vue?vue&type=template&id=5637192e&", function () {
      api.rerender('5637192e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/PageComponentSelector.vue"
export default component.exports